<template>
    <div>
        <ul>
            <li v-for="result in responses" :key="result.name">
                {{ result.name }} <br />
                {{ result.selection }} <br />
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapState } from "vuex";

    export default {
        name: "Data",
        computed: {
            ...mapState({
                results: (state) => state.results,
            }),

            responses() {
                return this.results.map((question) => {
                    // console.log(question.selection)
                    let selection;
                    // if is array = if it's a list of checkbox selections
                    if (Array.isArray(question.selection)) {
                        selection = question.selection;
                    } else {
                        selection = question.options.find((option) => {
                            console.log(option.value);
                            return option.value == question.selection;
                        });
                    }
                    return {
                        name: question.name,
                        selection: selection,
                    };
                });
            },
        },
    };
</script>
